import { z } from "zod"
import { DEFAULT_CREDIT_TYPE_CONFIG } from "@/src/features/internalUsers/ui/CreditTypeConfigSection"
import { CHARGING_TYPE_OPTIONS, DEFAULT_CHARGING_TYPE } from "@/src/features/internalUsers/constants"

const ChargingTypeEnum = z.enum(CHARGING_TYPE_OPTIONS.map((o: { value: string }) => o.value) as [string, ...string[]])

const nonNegativeNumericString = (message = "Value must be 0 or greater") =>
    z.string().refine((val) => {
        const num = Number(val)
        return !Number.isNaN(num) && num >= 0
    }, message)

export const CreditTypeConfigSchema = z.object({
    credits: z.coerce.number().min(0),
    pulseRateMinsPerCredit: nonNegativeNumericString(),
    maxCreditsPerCall: nonNegativeNumericString(),
    pulse: z.coerce.number().min(0),
    proctoring: z.boolean(),
    cefr: z.boolean(),
})

export type CreditTypeConfigFormValues = z.infer<typeof CreditTypeConfigSchema>

export const CreateWorkspaceFormSchema = z.object({
    workspaceName: z.string().min(1, "Workspace name is required"),
    websiteLink: z.string(),
    aboutCompany: z.string(),
    videoEnabled: z.boolean(),
    audioEnabled: z.boolean(),
    videoConfig: CreditTypeConfigSchema,
    audioConfig: CreditTypeConfigSchema,
    outboundAudioConfig: CreditTypeConfigSchema,
    attemptFrequency: nonNegativeNumericString(),
    chargingType: ChargingTypeEnum,
})

export type CreateWorkspaceFormValues = z.infer<typeof CreateWorkspaceFormSchema>

export const DEFAULT_CREATE_WORKSPACE_FORM_VALUES: CreateWorkspaceFormValues = {
    workspaceName: "",
    websiteLink: "",
    aboutCompany: "",
    videoEnabled: false,
    audioEnabled: false,
    videoConfig: { ...DEFAULT_CREDIT_TYPE_CONFIG },
    audioConfig: { ...DEFAULT_CREDIT_TYPE_CONFIG },
    outboundAudioConfig: { ...DEFAULT_CREDIT_TYPE_CONFIG },
    attemptFrequency: "3",
    chargingType: DEFAULT_CHARGING_TYPE,
}
